import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NceService } from '../../nce/services/nce.service';
import { STATIC_VALUE } from '../../shared/configuration/static.value';
import { FileService } from '../../shared/services/file.service';
import { StorageService } from '../../shared/services/storage.service';
import { LayoutService } from '../../shared/services/layout.service';

@Component({
	selector: 'nce-admin-request',
    templateUrl: '../../shared/components/preview/preview-parent.component.html'
})
export class NceAdminRequestComponent implements OnInit {

    constructor(
        private _layoutService: LayoutService,
        private _activatedRoute: ActivatedRoute,
        private _fileService: FileService,
        private _storageService: StorageService,
        private _nceService : NceService
    ){}
    
    vNCEid: number;
    sub: any;
	
    ngOnInit(){
        this.sub = this._activatedRoute.params.subscribe(params => {
            this.vNCEid = params['id'];
        });
        this._layoutService.setCurrentPage('nce-admin-request');
        this._fileService.vFiles = [];
        this._nceService.loadAdminDetailNCE(this.vNCEid).then(
            (resolve) => {
                this.setCurrentFlow();
            },
            (reject) => {

            }
        );
    }

    ngOnDestroy() {
        this._storageService.removeSessionItem('nceFiles');
        this._storageService.removeSessionItem('nceMultipleFiles');
        this._storageService.removeSessionItem('nceNewMultipleFiles');
        this._storageService.removeSessionItem('extensionNCE');
        this._fileService.vFiles = [];
    }

    setCurrentFlow(){
        if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_IN_PROGRESS ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_FAILED || 
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PAYMENT_PENDING){
            this._layoutService.setNCEFlow('nce-payment');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_SCHEDULE || 
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_PROVISIONING){
            this._layoutService.setNCEFlow('nce-briefing-session');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_TRIAL_HOLE_INSPECTION ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.WAIT_DIVERSION||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_SCHEDULE){
            this._layoutService.setNCEFlow('nce-make-appointment');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_BRIEFING_DOCUMENT ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_BRIEFING_DOCUMENT){
            this._layoutService.setNCEFlow('nce-briefing-document');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_APPOINTMENT_DOCUMENT ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED_APPOINTMENT_DOCUMENT){
            this._layoutService.setNCEFlow('nce-appointment-document');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPOINTMENT_DOCUMENT_UPLOAD){
            this._layoutService.setNCEFlow('nce-appointment-upload');
        } else if(this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL_REJECTED ||
            this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.INSPECTION_FINAL_APPROVAL){
            this._layoutService.setNCEFlow('nce-apply-for-final-approval');
        } else if(
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.PENDING_FINAL||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.REJECTED||                
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPROVED || 
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.EXPIRED ||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLICATION_EXPIRED ||
                this._nceService.vDetailNCE.status_description === STATIC_VALUE.ALL_NCE_STATUS.CANCELLED){
                this._layoutService.setNCEFlow('nce-final-approval');
        }
    }

}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce-admin/components/request.component.ts